import { animate, animation, style } from '@angular/animations';

export const enterAnimation = animation([
  style({ transform: 'scale(0.5)', opacity: 0 }),
  animate('300ms', style({ transform: 'scale(1)', opacity: 1 })),
]);

export const leaveAnimation = animation([
  style({ transform: 'scale(1)', opacity: 1, height: '*' }),
  animate(
    '300ms',
    style({
      transform: 'scale(0.5)',
      opacity: 0,
      height: '0px',
      margin: '0px',
    })
  ),
]);
